import $ from 'jquery';
import companiesSlideshow from '../modules/slideshow/create_companies_slideshow';
export default () => {

    const $companiesIndexLetters = $('.companies-index-letter');
    const $companiesContainer = $('.companies-container');
    const $arrow = $('.arrow');
    const $letterPreview = $('.letter-preview');

    $companiesIndexLetters.one('click', function (e) {

        let letter = $(this).data('letter');

        $.get('https://api.fastcompany.com/v1/packages/companies/search/pattern?pattern=' + encodeURIComponent(letter), function (data) {

            // Let's group the companies every 10 elements
            var groups = [],
                currentGroup = [],
                len = data.rows.length,
                i;

            for (i = 0; i < len; i++) {
                let currentItem = data.rows[i];

                if ((i % 10) === 0 && i > 0) {
                    groups.push(currentGroup);
                    currentGroup = [];
                }
                currentGroup.push(`<div class="list-company"><div class="company"><h4 class="company-name"><a href="/company/${currentItem.url}">${currentItem.name}</a></h4></div></div>`);
            }

            groups.push(currentGroup);

            // Let's join the data every 3 groups which is a slideshow page
            var slideShow = [],
                slideShowPage = [];

            for (i = 0; i < groups.length; i++) {
                if ((i % 3) === 0 && i > 0) {
                    slideShow.push(slideShowPage);
                    slideShowPage = [];
                }
                slideShowPage.push(groups[i]);
            }

            slideShow.push(slideShowPage);

            // For testing...how to create the html
            for (i = 0; i < slideShow.length; i++) {
                var page = slideShow[i];

                var column1 = page[0] ? page[0].join('') : '';
                var column2 = page[1] ? page[1].join('') : '';
                var column3 = page[2] ? page[2].join('') : '';

                $(e.currentTarget).find('.companies-list').append(`<div class="companies-column-container slide"><div class="companies-column">${column1}</div><div class="companies-column">${column2}</div><div class="companies-column">${column3}</div></div>`);
            }

            companiesSlideshow(e.currentTarget.id);

        });
    });

    $companiesIndexLetters.click(function (e) {

        if ($(e.target).is('a') || $(e.target).parent().is('a') || $(e.target).is('button')) {
            return;
        }
        $(this).find($companiesContainer).slideToggle(300);
        $(this).find($arrow).toggleClass('arrow arrow-down');
        $(this).find($letterPreview).toggleClass('letter-preview letter-preview-hidden');

    });
};
